export default "__VITE_ASSET__B6n5eP7E__"